/**
 * Bundle Cart Manager v11-smooth
 * 
 * Based on v10-fixed. Replaces window.location.reload() with
 * Section Rendering API for smooth price updates without page flash.
 */
(function() {
  'use strict';

  var cachedCart = null;
  var cachedBundlePrices = null;
  var origFetch = window.fetch;
  var FIXING_SIBLINGS = false;
  var LAST_FIX_PASSTHROUGH = false; /* flag: let last fix go through theme's handler */

  /* Expose for pre-checkout bypass */
  window.__origFetch = origFetch;

  function getBundleTier(prices, qty) {
    if (!prices || typeof prices !== 'object') return null;
    var tiers = Object.keys(prices).map(Number).filter(function(n){ return !isNaN(n); }).sort(function(a,b){return a-b;});
    if (!tiers.length) return null;
    var best = null;
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i]) best = tiers[i];
    }
    return best !== null ? prices[String(best)] : null;
  }

  async function loadCart() {
    try {
      var res = await origFetch('/cart.json', {cache:'no-store'});
      cachedCart = await res.json();
      if (cachedCart && cachedCart.attributes && cachedCart.attributes._bundle_prices_json) {
        try { cachedBundlePrices = JSON.parse(cachedCart.attributes._bundle_prices_json); } catch(e) {}
      }
    } catch(e) {}
  }

  /* Detect currency format from existing price element on the page */
  function detectCurrencyFormat() {
    /* Read a compare-at-price (always server-rendered with correct currency) */
    var sample = document.querySelector('.cart-items__price .compare-at-price');
    if (sample) {
      var text = sample.textContent.trim();
      /* Extract: symbol/prefix, decimal separator, suffix */
      /* Examples: €36,99 | 899 Kč | 14 990 Ft | 149,99 zł | 149,99 lei */
      var match = text.match(/^([^\d]*)([\d\s.,]+)\s*(.*)$/);
      if (match) {
        var prefix = match[1].trim();
        var numPart = match[2].trim();
        var suffix = match[3].trim();
        var usesComma = numPart.indexOf(',') !== -1;
        var hasDecimals = usesComma || (numPart.indexOf('.') !== -1 && numPart.split('.')[1] && numPart.split('.')[1].length <= 2);
        var usesSpaceThousands = numPart.indexOf(' ') !== -1;
        return { prefix: prefix, suffix: suffix, usesComma: usesComma, hasDecimals: hasDecimals, usesSpaceThousands: usesSpaceThousands };
      }
    }
    /* Default: EUR format */
    return { prefix: '€', suffix: '', usesComma: true, hasDecimals: true, usesSpaceThousands: false };
  }

  function formatPrice(num, fmt) {
    var str;
    if (fmt.hasDecimals) {
      str = num.toFixed(2);
      if (fmt.usesComma) {
        str = str.replace('.', ',');
      }
    } else {
      str = Math.round(num).toString();
    }
    /* Add space for thousands (e.g. 7 990) */
    if (fmt.usesSpaceThousands) {
      var parts = str.split(fmt.usesComma ? ',' : '.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      str = fmt.hasDecimals ? parts.join(fmt.usesComma ? ',' : '.') : parts[0];
    }
    return (fmt.prefix ? fmt.prefix : '') + str + (fmt.suffix ? ' ' + fmt.suffix : '');
  }

  /* Direct DOM price update — find price elements and patch text */
  async function updatePricesInDOM() {
    try {
      /* Fetch fresh cart to get correct _bundle_price values */
      var res = await origFetch('/cart.js', {cache:'no-store'});
      var cart = await res.json();
      cachedCart = cart;
      if (!cart || !cart.items) return;

      var fmt = detectCurrencyFormat();

      /* Find all cart item rows — they contain text-component with price */
      var priceEls = document.querySelectorAll('.cart-items__price');
      
      for (var i = 0; i < cart.items.length && i < priceEls.length; i++) {
        var item = cart.items[i];
        var bp = item.properties && item.properties._bundle_price;
        if (!bp) continue;

        var num = parseFloat(bp);
        if (isNaN(num)) continue;
        var formatted = formatPrice(num, fmt);

        /* Update the text-component and its inner span */
        var tc = priceEls[i].querySelector('text-component');
        if (tc) {
          var span = tc.querySelector('span');
          if (span) span.textContent = formatted;
          tc.setAttribute('value', formatted);
        }
      }

      /* Also update cart summary totals */
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch(e) {
      console.warn('[BCM] updatePricesInDOM failed:', e);
    }
  }

  function calcBundlePrice(lineIndex, newQty) {
    if (!cachedCart || !cachedCart.items || !cachedBundlePrices) return null;
    var targetItem = cachedCart.items[lineIndex - 1];
    if (!targetItem) return null;
    var props = targetItem.properties || {};
    if (!props._bundle_price && !props._bundle) return null;
    var pid = String(targetItem.product_id);
    var totalQty = 0;
    for (var i = 0; i < cachedCart.items.length; i++) {
      var item = cachedCart.items[i];
      if (String(item.product_id) === pid) {
        if (i === lineIndex - 1) {
          totalQty += newQty;
        } else {
          totalQty += item.quantity;
        }
      }
    }
    if (totalQty <= 0) return null;
    var bundlePrice = getBundleTier(cachedBundlePrices, totalQty);
    return bundlePrice !== null ? String(bundlePrice) : null;
  }

  function calcBundlePriceByKey(itemKey, newQty) {
    if (!cachedCart || !cachedCart.items || !cachedBundlePrices) return null;
    var targetIdx = -1;
    for (var i = 0; i < cachedCart.items.length; i++) {
      if (cachedCart.items[i].key === itemKey) { targetIdx = i; break; }
    }
    if (targetIdx === -1) return null;
    return calcBundlePrice(targetIdx + 1, newQty);
  }

  /* --- After any cart/change, fix ALL siblings --- */
  async function fixSiblings(changedProductId) {
    if (FIXING_SIBLINGS) return;
    FIXING_SIBLINGS = true;

    try {
      var res = await origFetch('/cart.js', {cache:'no-store'});
      var cart = await res.json();
      cachedCart = cart;
      if (!cart || !cart.items) { FIXING_SIBLINGS = false; setTimeout(initCsCarousel, 300); return; }

      var pid = String(changedProductId);
      var totalQty = 0;
      cart.items.forEach(function(it) {
        if (String(it.product_id) === pid) totalQty += it.quantity;
      });
      console.log('[BCM] fixSiblings pid=' + pid + ' totalQty=' + totalQty);

      /* Try __bundlePrices first, then cachedBundlePrices */
      var correctPrice = null;
      if (window.__bundlePrices && window.__bundlePrices[pid]) {
        var pd = window.__bundlePrices[pid];
        var ck = Object.keys(pd)[0];
        if (ck) correctPrice = getBundleTier(pd[ck], totalQty);
      }
      if (correctPrice === null && cachedBundlePrices) {
        correctPrice = getBundleTier(cachedBundlePrices, totalQty);
      }
      if (correctPrice === null) { console.log('[BCM] no correctPrice found'); FIXING_SIBLINGS = false; setTimeout(initCsCarousel, 300); return; }

      var expected = String(correctPrice);
      console.log('[BCM] expected price=' + expected);

      var fixes = [];
      cart.items.forEach(function(it) {
        if (String(it.product_id) !== pid) return;
        var props = it.properties || {};
        if (!props._bundle_price && !props._bundle) return;
        if (String(props._bundle_price || '') !== expected) {
          fixes.push({
            key: it.key,
            quantity: it.quantity,
            properties: Object.assign({}, props, { _bundle_price: expected })
          });
        }
      });

      console.log('[BCM] fixes needed: ' + fixes.length, fixes.map(function(f){return f.key;}));

      /* Fix ALL items via origFetch, then patch DOM directly */
      for (var i = 0; i < fixes.length; i++) {
        var fix = fixes[i];
        var payload = JSON.stringify({ id: fix.key, quantity: fix.quantity, properties: fix.properties });
        var fixRes = await origFetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: payload
        });
        var fixData = await fixRes.json();

        /* After each fix, update keys from response */
        if (fixData && fixData.items) {
          cachedCart = fixData;
          for (var j = i + 1; j < fixes.length; j++) {
            for (var k = 0; k < fixData.items.length; k++) {
              var ci = fixData.items[k];
              if (String(ci.product_id) === pid && ci.properties && String(ci.properties._bundle_price || '') !== expected) {
                fixes[j].key = ci.key;
                fixes[j].quantity = ci.quantity;
                fixes[j].properties = Object.assign({}, ci.properties, { _bundle_price: expected });
                break;
              }
            }
          }
        }
      }

      FIXING_SIBLINGS = false;
      /* Directly patch price text in DOM, then check gifts */
      setTimeout(updatePricesInDOM, 10);
      setTimeout(manageGifts, 100);
      /* Re-init cross-sell carousel after cart update */
      setTimeout(initCsCarousel, 500);
    } catch(e) {
      console.error('[BCM] fixSiblings error:', e);
      FIXING_SIBLINGS = false;
      setTimeout(refreshCartSection, 100);
      setTimeout(initCsCarousel, 600);
    }
  }

  /* Intercept fetch */
  window.fetch = function() {
    var args = Array.prototype.slice.call(arguments);
    var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url ? args[0].url : '');

    /* Skip our own sibling fix calls and pre-checkout calls */
    if (FIXING_SIBLINGS || window.__bypassBundleInterceptor || LAST_FIX_PASSTHROUGH) {
      return origFetch.apply(this, args);
    }

    if (url.indexOf('/cart/change') !== -1 && cachedBundlePrices) {
      try {
        var opts = args[1] || {};
        var bodyStr = opts.body || '';
        var bodyObj = JSON.parse(bodyStr);
        var changedPid = null;

        var newBP = null;
        if (bodyObj.line !== undefined && bodyObj.quantity !== undefined) {
          newBP = calcBundlePrice(bodyObj.line, bodyObj.quantity);
          if (cachedCart && cachedCart.items[bodyObj.line - 1]) {
            changedPid = cachedCart.items[bodyObj.line - 1].product_id;
          }
        } else if (bodyObj.id !== undefined && bodyObj.quantity !== undefined) {
          newBP = calcBundlePriceByKey(bodyObj.id, bodyObj.quantity);
          for (var i = 0; cachedCart && i < cachedCart.items.length; i++) {
            if (cachedCart.items[i].key === bodyObj.id) {
              changedPid = cachedCart.items[i].product_id;
              break;
            }
          }
        }

        if (newBP !== null) {
          var itemIdx = bodyObj.line ? bodyObj.line - 1 : -1;
          if (itemIdx === -1 && bodyObj.id) {
            for (var i = 0; i < cachedCart.items.length; i++) {
              if (cachedCart.items[i].key === bodyObj.id) { itemIdx = i; break; }
            }
          }
          if (itemIdx >= 0 && cachedCart.items[itemIdx]) {
            var currentProps = cachedCart.items[itemIdx].properties || {};
            bodyObj.properties = Object.assign({}, currentProps, { _bundle_price: newBP });
            opts.body = JSON.stringify(bodyObj);
            args[1] = opts;
          }
        }

        /* Call original and handle response */
        var result = origFetch.apply(this, args);

        result.then(function(response) {
          try {
            response.clone().json().then(function(data) {
              if (data && data.items) {
                cachedCart = data;
                if (data.attributes && data.attributes._bundle_prices_json) {
                  try { cachedBundlePrices = JSON.parse(data.attributes._bundle_prices_json); } catch(e) {}
                }
              }
              /* Fix siblings after primary change */
              if (changedPid) {
                setTimeout(function() { fixSiblings(changedPid); }, 10);
              }
            }).catch(function() {
              if (changedPid) setTimeout(function() { fixSiblings(changedPid); }, 10);
            });
          } catch(e) {
            if (changedPid) setTimeout(function() { fixSiblings(changedPid); }, 10);
          }
        }).catch(function(){});

        return result;
      } catch(e) {}
    }

    /* Pass through all other requests */
    var result = origFetch.apply(this, args);

    /* Update cache from cart responses + fix siblings on add */
    if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1 || url.indexOf('/cart/add') !== -1) {
      var isAdd = url.indexOf('/cart/add') !== -1;
      result.then(function(response) {
        try {
          response.clone().json().then(function(data) {
            if (data && data.items) {
              cachedCart = data;
              if (data.attributes && data.attributes._bundle_prices_json) {
                try { cachedBundlePrices = JSON.parse(data.attributes._bundle_prices_json); } catch(e) {}
              }
            }
            /* After /cart/add, fix siblings for the added product */
            if (isAdd && data) {
              var addedPid = null;
              /* /cart/add returns the added item(s), not full cart */
              if (data.product_id) {
                addedPid = data.product_id;
              } else if (data.items && data.items.length > 0) {
                addedPid = data.items[0].product_id;
              }
              if (addedPid) {
                console.log('[BCM] /cart/add detected, pid=' + addedPid + ', triggering fixSiblings');
                /* Need fresh cart data first */
                loadCart().then(function() {
                  setTimeout(function() { fixSiblings(addedPid); }, 10);
                  setTimeout(manageGifts, 200);
                });
              }
            }
          }).catch(function(){ setTimeout(loadCart, 100); });
        } catch(e) { setTimeout(loadCart, 100); }
      }).catch(function(){});
    }

    return result;
  };

  /* XHR intercept */
  var origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this._bundleUrl = url;
    return origXHROpen.apply(this, arguments);
  };
  var origXHRSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function(body) {
    if (FIXING_SIBLINGS) return origXHRSend.call(this, body);
    var url = this._bundleUrl || '';
    if (url.indexOf('/cart/change') !== -1 && cachedBundlePrices && body) {
      try {
        var bodyObj = JSON.parse(body);
        var newBP = null;
        if (bodyObj.line !== undefined && bodyObj.quantity !== undefined) {
          newBP = calcBundlePrice(bodyObj.line, bodyObj.quantity);
        } else if (bodyObj.id !== undefined && bodyObj.quantity !== undefined) {
          newBP = calcBundlePriceByKey(bodyObj.id, bodyObj.quantity);
        }
        if (newBP !== null) {
          var itemIdx = bodyObj.line ? bodyObj.line - 1 : -1;
          if (itemIdx === -1 && bodyObj.id) {
            for (var i = 0; i < cachedCart.items.length; i++) {
              if (cachedCart.items[i].key === bodyObj.id) { itemIdx = i; break; }
            }
          }
          if (itemIdx >= 0 && cachedCart.items[itemIdx]) {
            var currentProps = cachedCart.items[itemIdx].properties || {};
            bodyObj.properties = Object.assign({}, currentProps, { _bundle_price: newBP });
            body = JSON.stringify(bodyObj);
          }
        }
      } catch(e) {}
    }
    return origXHRSend.call(this, body);
  };

  /* ====== GIFT ITEMS UI — hide qty controls + "Default" text ====== */
  function styleGiftItems() {
    if (typeof document === 'undefined' || !cachedCart || !cachedCart.items) return;

    /* Find gift item indices */
    var giftIndices = [];
    cachedCart.items.forEach(function(item, idx) {
      if (item.properties && item.properties._is_gift) {
        giftIndices.push(idx);
      }
    });
    if (giftIndices.length === 0) return;

    /* Find all cart item rows — skip header row (has <th>) */
    var allRows = document.querySelectorAll('tr.cart-items__table-row');
    var rows = [];
    allRows.forEach(function(r){ if (!r.querySelector('th')) rows.push(r); });

    giftIndices.forEach(function(idx) {
      var row = rows[idx];
      if (!row) return;

      /* Hide "Default" variant text — find small/span with "Default" text */
      var allText = row.querySelectorAll('td span, td small, td p, td div');
      allText.forEach(function(el) {
        if (el.textContent.trim() === 'Default' || el.textContent.trim() === 'Default Title') {
          el.style.display = 'none';
        }
      });

      /* Hide quantity controls (+/- buttons and input) */
      var qtyEls = row.querySelectorAll('quantity-input, .quantity, [class*="quantity"]');
      qtyEls.forEach(function(el) {
        el.style.display = 'none';
      });
    });
  }

  /* ====== FREE GIFT MANAGEMENT ====== */
  var MANAGING_GIFTS = false;

  async function manageGifts() {
    if (MANAGING_GIFTS) return;
    MANAGING_GIFTS = true;

    try {
      var res = await origFetch('/cart.js', {cache:'no-store'});
      var cart = await res.json();
      cachedCart = cart;
      if (!cart || !cart.items) { MANAGING_GIFTS = false; return; }

      var gifts = window.__freeGifts || {};
      if (Object.keys(gifts).length === 0) { MANAGING_GIFTS = false; return; }

      /* Sum qty per product (exclude gift items) */
      var qtyByProduct = {};
      cart.items.forEach(function(it) {
        var props = it.properties || {};
        if (props._is_gift) return;
        var pid = String(it.product_id);
        qtyByProduct[pid] = (qtyByProduct[pid] || 0) + it.quantity;
      });

      /* Count how many gifts each variant_id should have */
      var neededGiftQty = {}; /* variant_id → count */
      for (var pid in gifts) {
        var cfg = gifts[pid];
        if (!cfg || !cfg.qty || !cfg.variant_id) continue;
        var totalQty = qtyByProduct[pid] || 0;
        var vid = String(cfg.variant_id);
        if (totalQty >= cfg.qty) {
          neededGiftQty[vid] = (neededGiftQty[vid] || 0) + 1;
        }
      }

      /* Find existing gift items in cart */
      var existingGifts = {}; /* variant_id → {key, quantity} */
      cart.items.forEach(function(it) {
        var props = it.properties || {};
        if (props._is_gift) {
          existingGifts[String(it.variant_id)] = { key: it.key, quantity: it.quantity };
        }
      });

      var changed = false;

      /* Add or update gift quantities */
      for (var vid in neededGiftQty) {
        var needed = neededGiftQty[vid];
        var existing = existingGifts[vid];

        if (!existing) {
          /* Add new gift */
          await origFetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({items: [{id: parseInt(vid), quantity: needed, properties: {_is_gift: 'true'}}]})
          });
          changed = true;
        } else if (existing.quantity !== needed) {
          /* Fix gift quantity (user changed it or multiple products qualify) */
          await origFetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: existing.key, quantity: needed})
          });
          changed = true;
        }
      }

      /* Remove gifts that are no longer needed */
      for (var vid in existingGifts) {
        if (!neededGiftQty[vid]) {
          await origFetch('/cart/change.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: existingGifts[vid].key, quantity: 0})
          });
          changed = true;
        }
      }

      MANAGING_GIFTS = false;

      if (changed) {
        window.location.reload();
      } else {
        styleGiftItems();
      }
    } catch(e) {
      MANAGING_GIFTS = false;
    }
  }

  /* Initial sync on cart page */
  if (window.location.pathname.indexOf('/cart') !== -1) {
    loadCart().then(function() {
      if (!cachedCart || !cachedCart.items) return;

      var qtyMap = {};
      cachedCart.items.forEach(function(item) {
        qtyMap[String(item.product_id)] = (qtyMap[String(item.product_id)] || 0) + item.quantity;
      });

      var needsUpdate = false;
      var updates = [];
      cachedCart.items.forEach(function(item) {
        var props = item.properties || {};
        if (!props._bundle_price && !props._bundle) return;
        var pid = String(item.product_id);
        var totalQty = qtyMap[pid];

        /* Try __bundlePrices first */
        var bundlePrice = null;
        if (window.__bundlePrices && window.__bundlePrices[pid]) {
          var pd = window.__bundlePrices[pid];
          var ck = Object.keys(pd)[0];
          if (ck) bundlePrice = getBundleTier(pd[ck], totalQty);
        }
        if (bundlePrice === null) bundlePrice = getBundleTier(cachedBundlePrices, totalQty);
        if (bundlePrice === null) return;

        var newBP = String(bundlePrice);
        if ((props._bundle_price || '') !== newBP) {
          needsUpdate = true;
          updates.push({
            key: item.key,
            quantity: item.quantity,
            props: Object.assign({}, props, { _bundle_price: newBP })
          });
        }
      });

      if (needsUpdate) {
        FIXING_SIBLINGS = true;
        (async function() {
          for (var i = 0; i < updates.length; i++) {
            var r = await origFetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: updates[i].key, quantity: updates[i].quantity, properties: updates[i].props })
            });
            var rd = await r.json();
            if (rd && rd.items) {
              cachedCart = rd;
              for (var j = i + 1; j < updates.length; j++) {
                for (var k = 0; k < rd.items.length; k++) {
                  var ci = rd.items[k];
                  if (ci.key !== updates[j].key && ci.properties && String(ci.properties._bundle_price || '') !== String(updates[j].props._bundle_price)) {
                    updates[j].key = ci.key;
                    break;
                  }
                }
              }
            }
          }
          FIXING_SIBLINGS = false;
          setTimeout(updatePricesInDOM, 10);
          setTimeout(manageGifts, 100);
        })();
      } else {
        /* No price updates needed, but still check gifts */
        manageGifts();
        styleGiftItems();
      }
    });
  } else {
    loadCart();
  }

  /* Style gift items after DOM is ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(styleGiftItems, 500); });
  } else {
    setTimeout(styleGiftItems, 500);
  }

  /* ====== CROSS-SELL CAROUSEL ====== */
  function initCsCarousel(){
    var track = document.querySelector('.pi-cs-track');
    
    if (!track) { console.log('[CS] no track found'); return; }

    console.log('[CS] initCsCarousel called, FIXING_SIBLINGS=' + FIXING_SIBLINGS, 'time=' + new Date().toISOString());

    /* Fetch fresh cart to know what's already in cart */
    (window.__origFetch || fetch)('/cart.js', {cache:'no-store'}).then(function(r){ return r.json(); }).then(function(cart){
      var inCartIds = (cart.items || []).map(function(it){ return String(it.product_id); });
      console.log('[CS] /cart.js returned ' + cart.items.length + ' items, productIds in cart:', inCartIds);

      var allCards = Array.from(track.querySelectorAll('.pi-cs-card'));
      /* Reset ALL cards first */
      allCards.forEach(function(card){
        card.style.display = '';
        card.removeAttribute('data-cs-hidden');
      });
      /* Then hide ones already in cart */
      allCards.forEach(function(card){
        var pid = card.getAttribute('data-cs-product-id');
        if (inCartIds.indexOf(pid) !== -1) {
          card.style.display = 'none';
          card.setAttribute('data-cs-hidden', '1');
        }
      });

      var cards = allCards.filter(function(c){ return c.getAttribute('data-cs-hidden') !== '1'; });
      console.log('[CS] allCards=' + allCards.length + ', visible=' + cards.length + ', hidden=' + (allCards.length - cards.length));
      allCards.forEach(function(c){ console.log('[CS]   card pid=' + c.getAttribute('data-cs-product-id') + ' hidden=' + (c.getAttribute('data-cs-hidden') === '1')); });
      var carousel = track.closest('.pi-cs-carousel') || track.parentElement;

      if (cards.length === 0) {
        console.log('[CS] all cards hidden → hiding carousel');
        carousel.style.cssText = 'display:none!important';
        return;
      }
      carousel.style.cssText = '';
      track.style.transform = 'translateX(0)';

      var current = 0;
      function goTo(idx){
        if (idx < 0) idx = cards.length - 1;
        if (idx >= cards.length) idx = 0;
        current = idx;
        track.style.transform = 'translateX(-' + (idx * 100) + '%)';
      }

      /* Clone arrow buttons to remove old event listeners */
      var prevBtn = carousel.querySelector('.pi-cs-prev');
      var nextBtn = carousel.querySelector('.pi-cs-next');
      if (prevBtn) { var np = prevBtn.cloneNode(true); prevBtn.parentNode.replaceChild(np, prevBtn); prevBtn = np; }
      if (nextBtn) { var nn = nextBtn.cloneNode(true); nextBtn.parentNode.replaceChild(nn, nextBtn); nextBtn = nn; }

      if (cards.length > 1) {
        if (prevBtn) { prevBtn.style.display = ''; prevBtn.addEventListener('click', function(){ goTo(current - 1); }); }
        if (nextBtn) { nextBtn.style.display = ''; nextBtn.addEventListener('click', function(){ goTo(current + 1); }); }
      } else {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
      }



      /* Touch swipe */
      var startX = 0, startY = 0, swiping = false;
      track.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; startY = e.touches[0].clientY; swiping = true; }, {passive:true});
      track.addEventListener('touchend', function(e){
        if (!swiping) return; swiping = false;
        var dx = startX - e.changedTouches[0].clientX, dy = startY - e.changedTouches[0].clientY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { dx > 0 ? goTo(current+1) : goTo(current-1); }
      }, {passive:true});

      /* Mouse swipe */
      var mouseDown = false, mx = 0;
      track.addEventListener('mousedown', function(e){ mouseDown = true; mx = e.clientX; e.preventDefault(); });
      document.addEventListener('mouseup', function(e){
        if (!mouseDown) return; mouseDown = false;
        var dx = mx - e.clientX;
        if (Math.abs(dx) > 40) { dx > 0 ? goTo(current+1) : goTo(current-1); }
      });

      /* Cross-sell add-to-cart buttons — use origFetch to bypass BCM interceptor */
      var boundCount = 0;
      track.querySelectorAll('[data-cs-add]').forEach(function(btn){
        if (btn.getAttribute('data-cs-bound') === '1') { console.log('[CS]   btn vid=' + btn.getAttribute('data-cs-add') + ' already bound, SKIPPING'); return; }
        btn.setAttribute('data-cs-bound', '1');
        boundCount++;
        btn.addEventListener('click', function(){
          var vid = this.getAttribute('data-cs-add');
          btn.disabled = true; btn.textContent = '...';
          (window.__origFetch || fetch)('/cart/add.js', {
            method:'POST', headers:{'Content-Type':'application/json'},
            body: JSON.stringify({items:[{id:parseInt(vid), quantity:1}]})
          }).then(function(r){ if(r.ok) window.location.reload(); else { btn.disabled=false; btn.textContent='DODAJ'; } })
            .catch(function(){ btn.disabled=false; btn.textContent='DODAJ'; });
        });
      });

      console.log('[CS] bound ' + boundCount + ' new buttons, calling goTo(0)');
      goTo(0);
    }).catch(function(e){ console.warn('[BCM] carousel init error:', e); });
  }

  /* Re-init carousel after every morphSection (DOM replacement) */
  if (window.location.pathname.indexOf('/cart') !== -1) {
    var _csTimer = null;
    var _csIniting = false;
    new MutationObserver(function(mutations){
      if (_csIniting) return;
      /* Only react to large DOM replacements (morphSection), not small tweaks */
      var dominated = mutations.some(function(m){ return m.addedNodes.length > 2 || m.removedNodes.length > 2; });
      if (!dominated) return;
      clearTimeout(_csTimer);
      _csTimer = setTimeout(function(){
        console.log('[CS] MutationObserver triggered initCsCarousel, FIXING_SIBLINGS=' + FIXING_SIBLINGS);
        var track = document.querySelector('.pi-cs-track');
        if (track) {
          _csIniting = true;
          initCsCarousel();
          setTimeout(function(){ _csIniting = false; }, 500);
        }
      }, 250);
    }).observe(document.documentElement, { childList: true, subtree: true });
    /* Initial init */
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){ setTimeout(initCsCarousel, 300); });
    } else {
      setTimeout(initCsCarousel, 300);
    }
  }

})();


/* ===== DESKTOP CART 2-COLUMN GRID ===== */
function initCartGrid() {
  if (window.innerWidth < 990) return;
  if (document.querySelector('.pi-cart-grid')) return; // already done
  
  var ci = document.querySelector('.cart-items');
  if (!ci) return;
  
  var productList = ci.querySelector('.cart-items__product-list');
  var summary = ci.querySelector('.pi-cart-summary');
  if (!productList || !summary) return;
  
  var grid = document.createElement('div');
  grid.className = 'pi-cart-grid';
  
  var left = document.createElement('div');
  left.className = 'pi-cart-left';
  
  var right = document.createElement('div');
  right.className = 'pi-cart-right';
  
  left.appendChild(productList);
  right.appendChild(summary);
  grid.appendChild(left);
  grid.appendChild(right);
  
  ci.appendChild(grid);
  console.log('[CartGrid] 2-column layout applied');
}

// Run on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCartGrid);
} else {
  initCartGrid();
}
// Also run after morph/section rendering
var _gridObs = new MutationObserver(function(muts) {
  if (!document.querySelector('.pi-cart-grid') && document.querySelector('.cart-items__product-list')) {
    initCartGrid();
  }
});
if (document.querySelector('.cart-items')) {
  _gridObs.observe(document.querySelector('.cart-items'), { childList: true, subtree: true });
}
